import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useContent() {
  return useQuery({
    queryKey: ["content"],
    queryFn: async () => (await api.get("/content")).data,
  });
}

export function usePortfolio() {
  return useQuery({
    queryKey: ["portfolio"],
    queryFn: async () => (await api.get("/portfolio")).data,
  });
}

export function useJobs() {
  return useQuery({
    queryKey: ["jobs"],
    queryFn: async () => (await api.get("/jobs")).data,
  });
}
